/* import __COLOCATED_TEMPLATE__ from './project-details-payment-charge-item.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { showModal } from 'sh-www/utils/modal-controls';
import { action } from '@ember/object';
import { BILLABLE_RECORD } from "sh-www/models/billable-record";
import { absoluteStoryhunterUrl } from 'sh-www/utils/url';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-project-details-payment-charge-item';

class ProjectDetailsPaymentChargeItem extends Component {
  @service media;
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get title() {
    const { type, dueAt } = this.args.billingRecord;
    switch (type) {
      case BILLABLE_RECORD.TYPES.PROJECT_ADVANCE:
        return 'Advance';
      case BILLABLE_RECORD.TYPES.PROJECT:
        return dueAt ?
          'Project completion' :
          'Project completion (Pending)';
      default:
        return '';
    }
  }

  get downloadLinkText() {
    const { id } = this.args.billingRecord;

    if (this.args.billingRecord.constructor.modelName === 'sh-payment') {
      return `Receipt #${id}`;
    } else {
      return `Invoice #${id}`;
    }
  }

  @action
  onRemoveExpeditePayoutClicked() {
    const { application, billingRecord, cancelExpeditePayment } = this.args;
    const bodyText = this.session.currentUser.isBuyer
      ? `Payout to ${application.seller.fullName} will no longer be expedited.`
      : 'You will no longer receive your balance within 3 business days.';

    showModal(this, 'confirmation', {
      isShowCancelButton: true,
      titleText: 'Remove expedited payout?',
      bodyText,
      actionButtonText: 'Remove',
      cancelButtonText: 'Cancel',
      confirmAction: () => {
        cancelExpeditePayment.perform(application, billingRecord.shPayment);
      },
    });
  }

  @action
  onExpeditePayoutClicked() {
    const { application, billingRecord, expeditePayment } = this.args;
    const estimatedPayoutDate = billingRecord.isDue ? application.nextAdvancePayoutDate : null;
    const estimatedPayoutDateText = billingRecord.isDue ? null : '3-5 business days after completion is confirmed';

    showModal(this, 'projects/expedite-freelancer-payout-modal', {
      application,
      billingRecord,
      estimatedPayoutDate,
      estimatedPayoutDateText,
      onExpeditePayoutConfirmed: () => {
        expeditePayment.perform(application, billingRecord.shPayment);
      },
    });
  }

  @action
  onDownloadClicked() {
    window.open(absoluteStoryhunterUrl(this.args.billingRecord.downloadPath));
  }
}

export default ProjectDetailsPaymentChargeItem;
